import * as types from './types'

export const API_EXAMPLE = 'password-reset/api'

// TRACKING
const tracker = (type, actionData = {}) => (dispatch, getState) => {
  const { track } = getState()
  const payload = Object.assign({}, track, actionData)

  return dispatch({
    type,
    meta: {
      analytics: {
        type,
        payload
      }
    }
  })
}

export const trackUsernameSuccess = isProspect => tracker(types.INPUT_USERNAME_SUCCESS, { isProspect })

export const trackUsernameFailure = () => tracker(types.INPUT_USERNAME_FAILURE)

export const trackSsnInput = () => tracker(types.INPUT_SSN)

export const trackDobInput = () => tracker(types.INPUT_DOB)

export const trackSubmit = () => tracker(types.SUBMIT)

export const trackSubmitSuccess = () => tracker(types.SUBMIT_SUCCESS)

export const trackSubmitFailure = () => tracker(types.SUBMIT_FAILURE)

export const trackSubmitFailureService = () => tracker(types.SUBMIT_FAILURE_SERVICE)

export const trackReEntry = () => tracker(types.RE_ENTRY)

export const trackLockedOut = () => tracker(types.LOCKED_OUT)

export const trackMissingData = () => tracker(types.MISSING_DATA)

export const trackDeprovisioned = () => tracker(types.DEPROVISIONED)

// INPUT VALIDATION
export function testUsername(value, dispatch, showError) {
  if (value.length < 3) {
    return {
      usernameError: showError ? 'Username must be at least 3 characters' : '',
      usernameValid: false
    }
  }

  return {
    usernameError: '',
    usernameValid: true
  }
}

export const validateUsername = ({ target }, showError = true) => dispatch => {
  const { value } = target
  const payload = testUsername(value, dispatch, showError)

  setTimeout(
    () =>
      dispatch({
        type: types.UPDATE_FORM_USERNAME_ERROR,
        payload
      }),
    300
  )
}

export function testSsn(value, dispatch) {
  const ssn = value.replace(/\D/g, '')
  if (ssn.toString().length !== 4) {
    return {
      ssnError: ' ',
      ssnValid: false
    }
  }
  dispatch(trackSsnInput())

  return {
    ssnError: '',
    ssnValid: true
  }
}
export const validateSsn = ({ target }) => dispatch => {
  const { value } = target
  const payload = testSsn(value, dispatch)

  return dispatch({
    type: types.UPDATE_FORM_SSN_ERROR,
    payload
  })
}

const testDob = (dob, dispatch) => {
  const value = dob.replace(/\D/g, '')
  if (value.length !== 8) {
    return {
      dobError: 'MM/DD/YYYY',
      dobValid: false
    }
  }
  dispatch(trackDobInput())

  return {
    dobError: '',
    dobValid: true
  }
}
export const validateDob = ({ target }) => dispatch => {
  const payload = testDob(target.value, dispatch)

  return dispatch({
    type: types.UPDATE_FORM_DOB_ERROR,
    payload
  })
}

// UPDATE INPUTS
export const updateUsername = ({ target }) => dispatch => {
  dispatch(validateUsername({ target }, false))

  return dispatch({
    type: types.UPDATE_FORM_USERNAME,
    payload: target.value.trim()
  })
}

export const updateSsn = ({ target }) => dispatch => {
  dispatch(validateSsn({ target }))

  return dispatch({
    type: types.UPDATE_FORM_SSN,
    payload: target.value.replace(/\D/g, '')
  })
}

const buildDate = value => {
  const dob = value.replace(/\D/g, '')
  if (dob.length < 3) {
    return `${dob.slice(0, 2)}`
  }
  if (dob.length < 5) {
    return `${dob.slice(0, 2)}/${dob.slice(2, 4)}`
  }

  return `${dob.slice(0, 2)}/${dob.slice(2, 4)}/${dob.slice(4, 8)}`
}

export const updateDob = ({ target }) => dispatch => {
  dispatch(validateDob({ target }))
  const payload = buildDate(target.value)

  return dispatch({
    type: types.UPDATE_FORM_DOB,
    payload
  })
}

export const viewNext = evt => {
  if (evt) {
    evt.preventDefault()
  }

  return {
    type: types.VIEW_NEXT
  }
}

export const viewBack = evt => {
  if (evt) {
    evt.preventDefault()
  }

  return {
    type: types.VIEW_BACK
  }
}

export const updateSubmitInvalid = payload => ({
  type: types.UPDATE_FORM_SUBMIT_INVALID,
  payload
})

const updateSubmitDisabled = payload => ({
  type: types.UPDATE_FORM_SUBMIT_DISABLED,
  payload
})

const updateSubmitText = payload => ({
  type: types.UPDATE_FORM_SUBMIT_TEXT,
  payload
})

export const updateSubmitWait = payload => ({
  type: types.UPDATE_FORM_SUBMIT_WAIT,
  payload
})

export const updateValidationError = payload => ({
  type: types.UPDATE_FORM_VALIDATION_ERROR,
  payload
})

export const userlockedOut = () => ({
  type: types.UPDATE_FORM_LOCKED_OUT
})

export const userDeprovisioned = () => ({
  type: types.UPDATE_FORM_DEPROVISIONED
})

export const userMissingData = () => ({
  type: types.UPDATE_FORM_MISSING_DATA
})

export const toggleServiceError = () => ({
  type: types.TOGGLE_SERVICE_ERROR
})

export const restart = evt => {
  if (evt) {
    evt.preventDefault()
  }

  return dispatch => {
    dispatch(updateSubmitInvalid(false))
    dispatch(updateSubmitDisabled(false))
    dispatch({
      type: types.VIEW_RESTART
    })
    dispatch(updateSubmitText('Continue'))
    dispatch(trackReEntry())
    dispatch({
      type: types.UPDATE_FORM_SUBMIT_ATTEMPS
    })
  }
}

export const errorModalAnalytics = () => {}

export const postForm = evt => {
  if (evt) {
    evt.preventDefault()
  }

  return (dispatch, getState, fetchMethod) => {
    const { form, submit } = getState()
    if (!submit.disabled) {
      dispatch(updateSubmitDisabled(true))
      dispatch(updateSubmitText('Verifying'))
      dispatch(updateSubmitWait(true))
      dispatch(updateValidationError(false))
      dispatch(trackSubmit())
      const { _csrf } = window

      return fetchMethod('/password-reset', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'x-csrf-token': _csrf
        },
        body: JSON.stringify({
          username: form.username ? form.username.trim() : '',
          ssn: form.ssn ? form.ssn.trim() : '',
          dob: form.dob ? form.dob.trim() : ''
        })
      })
        .then(({ redirectUrl, nmUniqueId }) => {
          try {
            if (window.heap && nmUniqueId) {
              window.heap.identify(nmUniqueId)
            }
          } catch (err) {
            //
          }
          dispatch(trackSubmitSuccess())
          window.location.href = redirectUrl

          return {}
        })
        .catch(err => {
          dispatch(updateSubmitWait(false))
          dispatch(viewBack())
          if (err.status === 423) {
            dispatch(trackLockedOut())

            return dispatch(userlockedOut())
          }

          if (err.status === 412) {
            dispatch(trackDeprovisioned())

            return dispatch(userDeprovisioned())
          }
          if (err.status === 418) {
            dispatch(trackMissingData())

            return dispatch(userMissingData())
          }
          if (err.status === 401) {
            dispatch(updateSubmitText('Retry'))
            dispatch(updateSubmitDisabled(false))
            dispatch(trackSubmitFailure())

            return dispatch(updateValidationError(true))
          }

          dispatch(trackSubmitFailureService())
          dispatch(updateSubmitDisabled(false))

          return dispatch(toggleServiceError())
        })
    }

    return null
  }
}

export const postUsername = () => (dispatch, getState, fetchMethod) => {
  const { form, submit } = getState()
  if (!submit.disabled) {
    dispatch(updateSubmitDisabled(true))
    dispatch(updateSubmitText('Verifying'))
    dispatch(updateSubmitWait(true))

    dispatch(trackSubmit())
    const { _csrf } = window

    return fetchMethod('/password-reset/username', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'x-csrf-token': _csrf
      },
      body: JSON.stringify({
        username: form.username ? form.username.trim() : ''
      })
    })
      .then(({ isProspect }) => {
        dispatch(updateSubmitDisabled(false))
        dispatch(updateSubmitText('Verify'))
        dispatch(updateSubmitWait(false))
        dispatch(trackUsernameSuccess(isProspect))
        if (!isProspect) {
          dispatch(viewNext())
          dispatch(updateValidationError(false))
        } else {
          dispatch(postForm())
        }

        return {}
      })
      .catch(() => {
        dispatch(updateSubmitWait(false))
        dispatch(trackSubmitFailureService())
        dispatch(updateSubmitDisabled(false))

        return dispatch(toggleServiceError())
      })
  }

  return {}
}

export const toggleHelpModal = evt => {
  if (evt) {
    evt.preventDefault()
  }

  return {
    type: types.TOGGLE_HELP_MODAL
  }
}
